import { useEffect } from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { useLocation, useNavigate, Link } from 'react-router'

import SAFARI from 'url:../assets/human-safari-kherson.jpg'
import Gallery from '../components/Gallery/Gallery'
import Events from '../components/Cities/Events'
import { images } from '../data/cities'
import { ralliesPhotos } from '../assets/rallies'
import { Resources } from '../components/Resources'
import LazyVideo from '../components/VideoPlayer/VideoPlayer'
import { routes } from '../routes'

import VIDEO from 'url:../assets/videos/Global Rally Main Video.MP4'

export default function Action() {
  const { t, i18n } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()

  const sizeClass1 =
    i18n.language === 'fr' || i18n.language === 'da'
      ? `wrap-break-word inline-block text-4xl sm:text-6xl md:text-6xl lg:text-7xl xl:text-9xl`
      : 'text-6xl md:text-8xl xl:text-9xl'

  useEffect(() => {
    if (location.state?.scrollToId) {
      const element = document.getElementById(location.state.scrollToId)
      if (element) {
        const isMobile = window.matchMedia('(max-width: 768px)').matches
        const offset = isMobile ? window.innerHeight * 0.1 : window.innerHeight * 0.8
        const top = element.getBoundingClientRect().top + window.scrollY + offset
        window.scrollTo({ top, behavior: 'smooth' })
      }
      navigate(location.pathname, { replace: true, state: {} })
    }
  }, [location.state, navigate, location.pathname])

  return (
    <div className='min-h-screen w-full text-gray-900 flex flex-col text-lg'>
      <section className='flex flex-col justify-center items-center w-full min-h-[75vh] text-center px-4 bg-gray-100 pb-10 pt-4 gap-8'>
        <p className='text-base opacity-60'>
          {t('action.intro')}{' '}
          <Link to={routes.help.path} className='text-blue-600 underline'>
            {t('action.helpLink')}
          </Link>
        </p>
        <LazyVideo
          src={VIDEO}
          className='w-full max-w-2xl object-cover align-middle cursor-pointer'
        />
        <h1 className='text-left md:text-center font-medium opacity-90 mb-4 wrap-break-word flex flex-col gap-4 text-6xl md:text-7xl'>
          <span dangerouslySetInnerHTML={{ __html: t('home.heroStop') }}></span>
          <div className='bg-black p-[0.5px] w-[80%] md:self-center'></div>
          <span>{t('home.heroSave')}</span>
        </h1>
        <p
          className={`inline-flex ${sizeClass1} font-semibold flex-wrap text-right items-center justify-end md:text-center text-blue-500 gap-4 mb-3`}
          dangerouslySetInnerHTML={{ __html: t('home.worldwideRally') }}
        ></p>
        <h2 className='text-3xl md:text-4xl mt-12 font-semibold mb-3 uppercase'>
          {t('home.heroTitle1')} <br /> {t('home.heroTitle2')}
        </h2>
        <p className='text-lg opacity-80'>#HumansAreNotTargets #StopHumanSafari #SaveKherson</p>
      </section>

      <section className='px-6 md:px-20 py-12 pb-20 text-center text-2xl leading-relaxed opacity-90 bg-gray-50 flex flex-col justify-center items-center md:flex-row'>
        <img src={SAFARI} alt='human safari drone' className='pb-8 md:pb-0 md:w-[50%]' />
        <p className='px-4'>
          <Trans i18nKey='home.infoText' components={{ bold: <strong /> }}></Trans>
        </p>
      </section>

      <div className='bg-blue-800 w-full text-gray-100 p-3 uppercase flex justify-center text-center text-xl md:text-2xl font-bold'>
        <button
          onClick={() => {
            const el = document.getElementById('posters-gallery')
            if (el) el.scrollIntoView({ behavior: 'smooth' })
          }}
          className='rounded-full text-blue-800 bg-white px-6 py-3 shadow-lg hover:bg-blue-700 cursor-pointer transition'
        >
          {t('home.seeGallery')}
        </button>
      </div>

      <Gallery id='rallies' images={ralliesPhotos} collapseToFirstRow={true} height='aspect-2/2' />

      <Events />

      <section
        aria-labelledby='un-recommendations-heading'
        className='flex flex-col gap-8 md:gap-12 px-6 py-25 bg-gray-50 text-center text-md md:text-xl leading-relaxed opacity-90'
      >
        <h3 id='un-recommendations-heading' className='text-4xl md:text-5xl font-medium'>
          {t('home.recommendationsTitle')}
        </h3>
        <article>
          <h4 className='bold underline pb-4'>
            <b className='text-2xl'>{t('home.recommendationsRussia')}</b>
          </h4>
          <ol>
            <li className='mb-2 text-2xl leading-relaxed'>{t('home.rusRec1')}</li>
            <li className='mb-2 text-2xl leading-relaxed'>{t('home.rusRec2')} </li>
            <li className='mb-2 text-2xl leading-relaxed'>{t('home.rusRec3')}</li>
          </ol>
        </article>
        <article>
          <h4 className='bold underline pb-4'>
            <b className='text-2xl'>{t('home.recommendationsUNStates')}</b>
          </h4>
          <ol>
            <li className='mb-2 text-2xl leading-relaxed'>{t('home.statesRec1')}</li>
            <li className='mb-2 text-2xl leading-relaxed'>{t('home.statesRec2')}</li>
          </ol>
        </article>
      </section>

      <Resources />
      <Gallery id='posters' images={images} downloadable />
    </div>
  )
}
